var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmessageTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55475_18920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7876 34.095C8.7876 32.5767 9.53087 31.1546 10.7774 30.2878L33.0936 14.7705C34.685 13.6639 36.7968 13.6639 38.3882 14.7705L60.7043 30.2878C61.9509 31.1546 62.6941 32.5767 62.6941 34.095V60.4602C62.6941 63.0212 60.618 65.0973 58.057 65.0973H13.4247C10.8637 65.0973 8.7876 63.0212 8.7876 60.4602V34.095Z",
    fill: "#124ADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8838 29.9386C17.8838 28.0244 19.4356 26.4727 21.3498 26.4727H49.5107C51.4249 26.4727 52.9767 28.0244 52.9767 29.9386V57.0887H17.8838V29.9386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8008 51.477L62.6941 37.8555V58.7606C62.6941 61.898 59.6437 64.1298 56.6535 63.1802L19.8008 51.477Z",
    fill: "#3D73FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55475_18920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6807 51.477L8.7873 37.8555V58.7606C8.7873 61.898 11.8378 64.1298 14.8279 63.1802L51.6807 51.477Z",
    fill: "#3D73FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.78711 53.155L32.2179 36.9125C34.3366 35.4438 37.1442 35.4438 39.2628 36.9125L62.6936 53.155V60.4579C62.6936 63.0189 60.6175 65.095 58.0565 65.095H13.4242C10.8632 65.095 8.78711 63.0189 8.78711 60.4579V53.155Z",
    fill: "#2562FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5176 3.05336C48.6048 2.89034 48.8385 2.89034 48.9257 3.05336L49.8764 4.83071C49.8979 4.87103 49.931 4.90405 49.9713 4.92562L51.7486 5.87627C51.9116 5.96346 51.9116 6.19716 51.7486 6.28435L49.9713 7.23499C49.931 7.25656 49.8979 7.28958 49.8764 7.3299L48.9334 9.09291C48.8447 9.25874 48.6057 9.25511 48.5221 9.08666L47.5704 7.16936C47.5468 7.12184 47.5076 7.08388 47.4594 7.06181L45.7379 6.27453C45.5638 6.19491 45.5562 5.95035 45.725 5.86006L47.4721 4.92562C47.5124 4.90406 47.5454 4.87103 47.567 4.83071L48.5176 3.05336Z",
    fill: "url(#paint0_linear_55475_18920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1656 11.3112C66.2528 11.1482 66.4865 11.1482 66.5737 11.3112L67.5243 13.0885C67.5459 13.1288 67.5789 13.1619 67.6192 13.1834L69.3966 14.1341C69.5596 14.2213 69.5596 14.455 69.3966 14.5422L67.6192 15.4928C67.5789 15.5144 67.5459 15.5474 67.5243 15.5877L66.5813 17.3507C66.4926 17.5166 66.2537 17.5129 66.17 17.3445L65.2183 15.4272C65.1947 15.3797 65.1555 15.3417 65.1073 15.3196L63.3859 14.5323C63.2118 14.4527 63.2042 14.2082 63.373 14.1179L65.12 13.1834C65.1604 13.1619 65.1934 13.1288 65.2149 13.0885L66.1656 11.3112Z",
    fill: "url(#paint1_linear_55475_18920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96344 26.8561C3.05063 26.6931 3.28433 26.6931 3.37152 26.8561L4.32217 28.6334C4.34373 28.6738 4.37676 28.7068 4.41707 28.7284L6.19443 29.679C6.35744 29.7662 6.35744 29.9999 6.19443 30.0871L4.41707 31.0377C4.37676 31.0593 4.34373 31.0923 4.32217 31.1326L3.3792 32.8956C3.2905 33.0615 3.05151 33.0578 2.96789 32.8894L2.01618 30.9721C1.99259 30.9246 1.9534 30.8866 1.90515 30.8645L0.183727 30.0773C0.00962314 29.9976 0.0020143 29.7531 0.170831 29.6628L1.91789 28.7284C1.9582 28.7068 1.99123 28.6738 2.01279 28.6334L2.96344 26.8561Z",
    fill: "url(#paint2_linear_55475_18920)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55475_18920",
    x: 8.40068,
    y: 36.6962,
    width: 45.5985,
    height: 28.2499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.966067,
    dy: 0.193213
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.676247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.554167 0 0 0 0 0.589352 0 0 0 0 0.633333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55475_18920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55475_18920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55475_18920",
    x1: 48.7509,
    y1: 2.64262,
    x2: 52.0842,
    y2: 6.76314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55475_18920",
    x1: 66.3989,
    y1: 10.9004,
    x2: 69.7321,
    y2: 15.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55475_18920",
    x1: 3.19673,
    y1: 26.4454,
    x2: 6.52995,
    y2: 30.5659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55475_18920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 11.491,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmessageTutorial);
export default __webpack_public_path__ + "static/media/icon.message_tutorial.0168be5973716242621a9ffa560c0788.svg";
export { ForwardRef as ReactComponent };